/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddCartItemDto } from '../../models/add-cart-item-dto';
import { ShoppingCartDto } from '../../models/shopping-cart-dto';

export interface ShoppingCartControllerAdd$Params {
      body: AddCartItemDto
}

export function shoppingCartControllerAdd(http: HttpClient, rootUrl: string, params: ShoppingCartControllerAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<ShoppingCartDto>> {
  const rb = new RequestBuilder(rootUrl, shoppingCartControllerAdd.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShoppingCartDto>;
    })
  );
}

shoppingCartControllerAdd.PATH = '/api/cart/add';
